import classNames from "classnames";
import React from "react";

import styles from "./index.module.scss";

interface HeaderProps {
  className?: string;
  main: string;
  rowOnMobile?: boolean;
  sub: string;
}

const Headline = (props: HeaderProps) => {
  const { className, main, rowOnMobile = false, sub } = props;

  const defaultHeadline = (
    <div className={classNames(styles.main, className)}>
      <div className={styles.mainText}>{main}</div>
      <span className={styles.verticalSeparator} />
      <div className={styles.subText}>{sub}</div>
    </div>
  );

  const rowMobileHead = (
    <div className={classNames(styles.rowMobileContainer)}>
      <div className={styles.mainText}>{main}</div>
      <span className={styles.verticalSeparator} />
      <div className={styles.subText}>{sub}</div>
    </div>
  );

  return rowOnMobile ? <>{rowMobileHead}</> : <>{defaultHeadline}</>;
};

export { Headline };
